'use strict';

require('../../style/index.css');

require('./index.css');

require('../../select/style/css');

require('../../input/style/css');


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/pagination/style/css.js
// module id = 456
// module chunks = 0